<template>
    <van-popup v-model="show" round position="bottom" :style="{ maxHeight: '60%' }">
        <div>
            <div class="selectContent">
                <div class="selectBtnRow">选择送达时间</div>
                <div class="dateGroup">
                    <div class="kouku-img" v-if="!timeList.length">
                        <img src="../../assets/img/koutu.png" />
                        <div>商铺不支持预定其他时间</div>
                    </div>
                    <ul v-else class="dateList" :style="listStyle">
                        <li
                            v-for="(hour,idx) in timeList"
                            :key="idx"
                            :class="{
                                'selectOn':idx == index
                                }"
                            @click="chooseDay(hour, idx)"
                        >{{hour.tab}}</li>
                    </ul>
                    <ul
                        v-if="(timeList[index] || {timePoints: []}).timePoints.length"
                        class="dateList"
                        :style="listStyle"
                    >
                        <li
                            v-for="(minutes,idx1) in timeList[index].timePoints"
                            :key="idx1"
                            @click="chooseTime(minutes)"
                        >
                            {{minutes.time}}
                            <span>{{minutes.deliveryFeeDescription}}</span>
                            <Svgs
                                v-if="time.deliveryTime == minutes.deliveryTime"
                                class="ele-time-icon"
                                color="#E60012"
                                name="iconyiwancheng"
                            ></Svgs>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: "TimePicker",
    props: ["timeList"],
    data() {
        return {
            show: false,
            listStyle: {},
            index: 0,
            time: ""
        };
    },
    activated() {
        this.show = false;
        this.index = 0;
        this.time = "";
        this.listStyle = {};
        this.setStyle();
    },
    methods: {
        open() {
            this.show = true;
        },
        chooseDay(day, idx) {
            this.index = idx;
        },
        chooseTime(time) {
            this.time = time;
            this.$emit("onOk", this.index, time);
            this.show = false;
        },
        setStyle() {
            this.listStyle = {
                height: window.innerHeight / 3 + "px"
            };
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.kouku-img {
    width: 100%;
    text-align: center;
    img {
        width: 40%;
    }

    div {
        margin: 0.2rem 0 0.8rem 0;
    }
}

.selectContent {
    background: #fff;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
}

.selectBtnRow {
    padding: 0.18rem 0;
    font-size: 0.16rem;
    text-align: center;
}

.line {
    position: absolute;
    height: 0.16rem;
    border-left: $smart-border-base;
    top: 0.12rem;
    left: 0;
}

.dateGroup {
    display: flex;
}

.dateList {
    background: #f8f8f8;
    width: 30%;
    overflow: scroll;
}

.dateList li {
    height: 0.47rem;
    line-height: 0.47rem;
    text-align: center;
}
.dateList:last-child {
    width: 70%;
    background: #fff;
    padding-left: 0.15rem;
    li {
        text-align: left;
        position: relative;
        span {
            color: $smart-color-info;
        }
        .ele-time-icon {
            position: absolute;
            right: 0.26rem;
            top: 0.15rem;
        }
    }
}

.selectOn {
    background: #fff;
}
</style>